module.exports = "<div class=\"spinner\" [class.active]=\"spin\">\r\n    <div class=\"lds-css\">\r\n        <div class=\"lds-wave\" style=\"width:100%;height:100%\">\r\n            <div></div>\r\n            <div></div>\r\n            <div></div>\r\n            <div></div>\r\n        </div>\r\n    </div>\r\n\r\n    <!-- <div class=\"progress\" *ngIf=\"progress && progress > -1\">\r\n        <div class=\"progress-bar\" role=\"progressbar\" [ngStyle]=\"{ 'width': progress + '%' }\"></div>\r\n    </div> -->\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/spinner/spinner.component.html
// module id = ./src/app/shared/components/spinner/spinner.component.html
// module chunks = main